import { ArticleCard } from '@components';
import { useScreenSize } from '@hooks';
import { Flex } from '@styles';
import { arrayOf, number, shape, string } from 'prop-types';
import React from 'react';

const ArticlesList = ({ articles }) => {
  const { isTabletLG } = useScreenSize();
  return (
    <Flex flexWrap="wrap" gap={4} mb={74} ml={isTabletLG ? 0 : 25} width="100%">
      {articles?.map((article) => (
        <ArticleCard
          articleId={article.id}
          articleImage={article.articleImage}
          isRead={article?.isRead}
          isWithBooklet={article?.isWithBooklet}
          titleText={article.titleText}
          wasSeenCount={article.wasSeenCount}
        />
      ))}
    </Flex>
  );
};

ArticlesList.propTypes = {
  articles: arrayOf(
    shape({
      articleImage: string,
      id: string,
      titleText: string,
      wasSeenCount: number,
    })
  ).isRequired,
};

export default ArticlesList;
